<template>
  <section id="SectionSetup">
    <Wrap class="lg">
      <div class="header">
        <h3 class="title">
          {{ $t('title') }}
        </h3>
      </div>

      <ol>
        <li>
          {{ $t('itemPreLink') }}
          <Route
            class="link-text"
            :title="$t('itemLinkText')"
            :to="{ name: $route.name, hash: '#FooterContact' }">
            {{ $t('itemLinkText') }}
          </Route>
        </li>
        <li v-for="item in $ta('items')" :key="item">
          {{ item }}
        </li>
      </ol>
    </Wrap>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss">
#SectionSetup {
  h2, h3 {
    display: inline;
  }

  h2 {
    color: $main;
  }

  .header {
    margin-bottom: 3rem;
  }

  li {
    color: $grey;
    margin-left: 1rem;
    padding: 1rem 0 1rem 2rem;
  }

  .link-text {
    text-decoration: underline;
  }
}
</style>

<i18n>
{
  "lt": {
    "title": "Padėsime Jums visuose saulės elektrinės įrengimo žingsniuose",
    "itemPreLink": "Susisiekite su mumis pasitarti dėl tinkamiausio saulės elektrinės sprendimo",
    "itemLinkText": "paskambindami ar užpildydami kontaktinę formą;",
    "items": [
      "Kreipkitės į APVA dėl paramos. Savo klientams užpildyti paramos prašymą padeda Nogrid konsultantai;",
      "Užpildykite mūsų partnerių BigBank užklausą dėl paskolos suteikimo ir per 2 val. darbo metu gaukite atsakymą;",
      "Gavus BigBank paskolą, pasirašysime sutartį ir pradėsime darbus;",
      "Nogrid specialistai dronų pagalba išmatuos Jūsų namo stogą, suprojektuos ir įrengs saulės elektrinę. Paruoš visus dokumentus, reikiamus prijungimui prie ESO tinklų;",
      "Pridavus elektrinę ESO, pradėsite generuoti saulės energiją. Padėsime Jums pasirinkti tinkamiausią ESO mokėjimo planą;",
      "Saulės elektrinės dokumentus priduosite APVA, kuri Jums išmokės suteiktą paramą. Gautos paramos sumą įmokėsite BigBank kaip išankstinį paskolos dalies grąžinimą (baudos netaikomos) ir ženkliai sumažinsite savo lizingo įmokas;",
      "Mėgausitės naudodami savo generuojamą ekologišką saulės energiją ir taupysite pinigus."
    ]
  }
}
</i18n>
